import { render, staticRenderFns } from "./SchoolFacialPageCreateForm.vue?vue&type=template&id=9d437dc8&scoped=true&"
import script from "./SchoolFacialPageCreateForm.vue?vue&type=script&lang=js&"
export * from "./SchoolFacialPageCreateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d437dc8",
  null
  
)

export default component.exports